module.exports = __webpack_public_path__ + "img/gi-color-horizontal.c090b82f.png";